import { ReferenceInput, required, AutocompleteInput, usePermissions, useTranslate } from 'react-admin';
import { useWatch, useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import { contractorFilterToQuery, groupFilterToQuery, collectionPointFilterToQuery } from '@/helpers/filters/filterToQuery';

export const DeviceRelationInputs = () => {
    const { isLoading, permissions } = usePermissions();
    const { setValue } = useFormContext();
    const selectedContractorId = useWatch({ name: 'contractorId' });
    const contractorFilter = selectedContractorId ? { contractorId: selectedContractorId } : null;
    const translate = useTranslate();
    if (isLoading) return null;

    return (
        <>
            {permissions.isAdmin && (
                <Box className='autocomplete-parent'>
                    <ReferenceInput source='contractorId' reference='contractor' perPage={25}>
                        <AutocompleteInput
                            filterToQuery={contractorFilterToQuery}
                            validate={required(translate('common.validation.required'))}
                            fullWidth={true}
                            disablePortal={true}
                            label={translate('common.contractor')}
                            onChange={() => {
                                setValue('groupId', null);
                                setValue('collectionPointId', null);
                            }}
                        />
                    </ReferenceInput>
                </Box>
            )}
            <Box className='autocomplete-parent'>
                <ReferenceInput source='groupId' reference='device-group' perPage={25} filter={contractorFilter}>
                    <AutocompleteInput
                        filterToQuery={groupFilterToQuery}
                        validate={required(translate('common.validation.required'))}
                        fullWidth={true}
                        disabled={!permissions.isAdmin || !selectedContractorId}
                        disablePortal={true}
                        label={translate('resources.device.fields.group')}
                    />
                </ReferenceInput>
            </Box>
            <Box className='autocomplete-parent'>
                <ReferenceInput source='collectionPointId' reference='collection-point' perPage={25} filter={contractorFilter}>
                    <AutocompleteInput
                        filterToQuery={collectionPointFilterToQuery}
                        validate={required(translate('common.validation.required'))}
                        fullWidth={true}
                        disabled={!permissions.isAdmin || !selectedContractorId}
                        label={translate('common.collectionPoint')}
                        disablePortal={true}
                    />
                </ReferenceInput>
            </Box>
        </>
    );
};
